import type { MainNavRoute, MainPath, MainRoute } from '../types';

import PERMISSIONS from '@snowit/utilities/permissions';

import { makeChildren } from '../utils';

export const CHALLENGE_TABS = [
  'info',
  'config',
  'goals',
  'sponsors',
  'prizes',
  'participants',
] as const;

export type ChallengeTabs = (typeof CHALLENGE_TABS)[number];

export const HomePath: MainPath = '/' as MainPath;

export const MyPartnerPath: MainPath = '/my_partner/:section?';
export const TurnstilesPath: MainPath = '/turnstiles/:id?';
export const ChallengesPath: MainPath = '/challenges/:id?/:section?';

export const HomeRoute: MainNavRoute = {
  path: '/' as `/${MainRoute}`,
  label: 'routes.home',
  icon: 'home',
  type: 2,
};

export const MY_PARTNER_TABS = [
  //
  'info',
  'export_users',
  'prices',
] as const;

export type MyPartnerTabs = (typeof MY_PARTNER_TABS)[number];

export const MyPartnerRoute: MainNavRoute = {
  path: '/my_partner',
  label: 'routes.my_partner',
  icon: 'partner',
  kb: 'https://doc.clickup.com/20614177/p/h/kn311-24081/a833690cc8ad8c6',
  permissions: [PERMISSIONS.MY_PARTNER__VIEW],
  type: 1,
  children: makeChildren<MyPartnerTabs>({
    info: { path: 'info', permissions: [PERMISSIONS.MY_PARTNER__EDIT] },
    export_users: { path: 'export_users' },
    prices: { path: 'prices', permissions: [PERMISSIONS.MY_PARTNER__PRICES] },
  }),
};

export const ChallengesRoute: MainNavRoute = {
  path: '/challenges',
  label: 'routes.challenges',
  icon: 'world_cup',
  permissions: [PERMISSIONS.CHALLENGES__LIST],
  type: 0,
  children: [
    {
      path: ':id',
      permissions: [PERMISSIONS.CHALLENGES__DETAILS, PERMISSIONS.CHALLENGES__CREATE],
      logic: 'OR',
      disowned: true,
      children: makeChildren<ChallengeTabs>({
        info: {
          path: 'info',
        },
        config: {
          path: 'config',
        },
        goals: {
          path: 'goals',
        },
        prizes: {
          path: 'prizes',
        },
        sponsors: {
          path: 'sponsors',
        },
        participants: {
          path: 'participants',
        },
      }),
    },
  ],
};

export const TurnstilesRoute: MainNavRoute = {
  path: '/turnstiles',
  label: 'routes.turnstiles',
  permissions: [PERMISSIONS.TURNSTILES__LIST],
  type: 0,
  children: [{ path: ':id', permissions: [PERMISSIONS.TURNSTILES__DETAILS] }],
};
